import React from "react";
import CardContainer from "../generic/CardContainer";
import InfoCard from "../generic/InfoCard";
// import YoutubeIframe from "../generic/YoutubeIframe";

interface Props {}

function MusicLivePage(props: Props) {
  // const {} = props

  return (
    <CardContainer>
      <InfoCard fitContentWidth>
        <p>Coming soon!</p>
        {/* <YoutubeIframe src="https://www.youtube.com/embed/n6mlAso668A?si=X3EOscsKVT2O23Oq" /> */}
      </InfoCard>
    </CardContainer>
  );
}

export default MusicLivePage;
